import { LoadingCircle } from '@/shared/ui'

import cl from './chat-loader.module.scss'

export const ChatLoader = () => {
	return (
		<div className={cl.root}>
			<LoadingCircle size={70} />
		</div>
	)
}
